import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigCollectionService } from '../services/config-collection.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AdminDeactivateGuard implements CanDeactivate<any> {

  constructor(private configCollectionService: ConfigCollectionService) {}

  canDeactivate(
    component: any,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    const targetUrl = nextState?.url || '';

    if (targetUrl.includes('/configurator')) {
      // Mostrar loading y esperar respuesta
      Swal.fire({
        title: 'Recargando caché...',
        text: 'Por favor espere',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      return this.configCollectionService.reloadAllCaches().pipe(
        map(() => {
          Swal.close();
          return true;
        })
      );
    } else {
      // Llamar sin esperar
      this.configCollectionService.reloadAllCaches().subscribe();
      return true;
    }
  }
}
